import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EmailService } from 'src/app/services/email-service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-edit-template',
    templateUrl: './edit-template.component.html',
    styleUrls: ['./edit-template.component.scss'],
    standalone: false
})
export class EditTemplateComponent implements OnInit {
  @ViewChild('messageInput') messageInputRef!: ElementRef<HTMLDivElement>;

  templateName: string = '';
  templateSubject: string = '';
  templateBody: string = '';
  templateDesc: string = '';
  attachments: any[] = [];
  templateKey: string = '';
  uploadedFiles: File[] = [];
  combinedAttachments: any[] = []; // New array to hold combined attachments

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EditTemplateComponent>,
    public emailService: EmailService,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    console.log('Data received in EditTemplateComponent:', this.data);

    if (this.data) {
      this.templateName = this.data.template_name || '';
      this.templateSubject = this.data.email_subject || '';
      this.templateBody = this.data.email_body || '';
      this.templateDesc = this.data.template_desc || '';
      this.templateKey = this.data.email_template_key || '';

      const templateKeyNumber = Number(this.templateKey);

      if (!isNaN(templateKeyNumber)) {
        this.emailService.getTemplateAttachments(templateKeyNumber)
          .then((response) => {
            console.log('Attachments fetched:', response);
            this.attachments = response.Attachments || []; // ✅ Fixed Here
            this.combineAttachments(); // Combine existing attachments with uploaded files
          })
          .catch((error) => {
            console.error('Error fetching attachments:', error);
          });
      } else {
        console.error('Invalid templateKey:', this.templateKey);
      }
    } else {
      console.error('No data received for EditTemplateComponent.');
    }
  }

  ngAfterViewInit() {
    this.messageInputRef.nativeElement.innerHTML = this.templateBody || '';
  }

  /**
   * Combine both existing and newly uploaded attachments
   */
  combineAttachments(): void {
    this.combinedAttachments = [];
  
    // Existing files
    this.combinedAttachments.push(...this.attachments.map(file => ({
      ...file,
      isTemplateFile: true,
      url: file.PreSignedUrl,
      name: file.attachment_file_name
    })));
  
    // Newly uploaded files
    this.combinedAttachments.push(...this.uploadedFiles.map((file, index) => ({
      name: file.name,
      isTemplateFile: false,
      index,
      file
    })));
  }
  


  /**
   * Removes an uploaded file from the list
   */
  removeUploadedFile(index: number): void {
    this.uploadedFiles.splice(index, 1);
    this.combineAttachments(); // Re-combine attachments after removal
  }

  async saveChanges(): Promise<void> {
    const formData = new FormData();
    formData.append('template_name', this.templateName || '');
    formData.append('email_subject', this.templateSubject || '');
    formData.append('email_body', this.templateBody || '');
    formData.append('template_desc', this.templateDesc || '');
    formData.append('email_template_key', this.templateKey || '');
  
    // 1. Add existing attachments (fetched from PreSignedUrl)
    for (const file of this.attachments) {
      const fileBlob = await this.urlToFile(file.PreSignedUrl, file.attachment_file_name);
      formData.append('attachments', fileBlob, file.attachment_file_name);
    }
  
    // 2. Add newly uploaded files
    this.uploadedFiles.forEach(file => {
      formData.append('attachments', file);
    });
  
    console.log('Submitting formData with attachments');
  
    this.emailService.editTemplates(formData)
      .then((response) => {
        console.log('Template updated successfully:', response);
        this.snackBar.open('Template updated successfully!', 'Close', {
          duration: 3000,
          panelClass: ['success-snackbar']
        });
        this.dialogRef.close(response);
      })
      .catch((error) => {
        console.error('Error updating template:', error);
        this.snackBar.open('Failed to update template. Please try again.', 'Close', {
          duration: 3000,
          panelClass: ['error-snackbar']
        });
      });
  }
  async urlToFile(url: string, fileName: string): Promise<File> {
    const response = await fetch(url);
    const blob = await response.blob();
    return new File([blob], fileName);
  }
  
  

  onTemplateDesc(event: Event): void {
    const target = event.target as HTMLTextAreaElement;
    this.templateDesc = target.value;
    console.log(this.templateDesc);
  }

  formatText(command: string): void {
    document.execCommand(command, false, undefined);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  popUpClose(): void {
    this.dialogRef.close();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    console.log("input", input);

    if (input.files && input.files.length > 0) {
      // Add selected files to the uploadedFiles array
      for (let i = 0; i < input.files.length; i++) {
        this.uploadedFiles.push(input.files[i]);
      }
    }

    // Recombine the attachments to include the new ones
    this.combineAttachments();
  }
  onMessageInput(event: Event): void {
    const inputElement = event.target as HTMLElement;
    this.templateBody = inputElement.innerHTML; // Update templateBody with the HTML content
  }
  removeFile(index: number): void {
    this.uploadedFiles.splice(index, 1);
    this.combineAttachments(); // Re-combine attachments after removal
  }
}
